<template>
    <div id="app" class="app">
        <v-content>
            <v-container fluid="true" text-xs-center class="mt-1 pt-5">
                <v-layout row wrap class="text-xs-center">
                    <v-flex xs12 sm8 md6 lg4 offset-sm2 offset-md3 offset-lg4>
                        <v-card color="white" class="ma-4 pa-1">
                            <img src="../assets/icon.png" class="logo">

                            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="login"
                                    class="ma-4 pa-2">
                                <v-text-field id="login_user_name_field"
                                              v-model="username" name="username"
                                              placeholder="" label="Username" required
                                              :append-icon="'person'"></v-text-field>
                                <v-text-field id="login_password_field"
                                              v-model="password" name="password"
                                              placeholder="" label="Password" required
                                              :append-icon="show ? 'visibility' : 'visibility_off'"
                                              :type="show ? 'text' : 'password'" class="input-group--focused"
                                              @click:append="show = !show"></v-text-field>
                                <v-btn id="login_button" type="submit" color="rgb(70, 70, 75)" dark large block
                                       class="mt-5"> Login
                                </v-btn>

                                <v-alert :value="isError" color="error" icon="warning">
                                    {{errorMessage}}
                                </v-alert>
                            </v-form>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>


    </div>
</template>

<script>

    import auth from '../auth'
    import {EventBus} from "../eventbus";
    import userinterface from "../interfaces/userinterface";

    export default {
        name: 'Login',

        data: () => ({
            username: '',
            password: '',
            isError: false,
            loginFailed: false,
            errorMessage: "",

            valid: true,
            show: false
        }),

        mounted() {
            EventBus.$on('userTokenExpired', () => {
                this.isError = true;
                this.errorMessage = "Your session has expired. To continue using the application please log in again.";
            });
        },

        methods: {

            async login() {

                let userLoggedIn = false;
                await auth.login(this.username, this.password, async loggedIn => {
                    userLoggedIn = loggedIn;
                });

                setTimeout(function () {
                    userLoggedIn = false;
                }, 2000);

                if (userLoggedIn.ok != null && !userLoggedIn.ok) {
                    if (userLoggedIn.status && userLoggedIn.status === 503) {
                        this.errorMessage = "Authentication server is currently not available. Please contact the technical support."
                    } else {
                        this.errorMessage = "Authentication failed. Please check your user credentials!";
                    }

                    this.isError = true;
                } else {
                    this.$router.replace(this.$route.query.redirect || '/');

                    let rights = JSON.parse(this.$cookies.get("userRights"));

                    let poolRead = false;
                    if (rights != null) {
                        rights.forEach(right => {
                            if (right.right === "PoolGroupRead" || right.right === "PoolModify") {
                                poolRead = true;
                            }
                        });
                    }

                    poolRead ? this.$router.push('macpools') : this.$router.push('');

                    await userinterface.setCurrentUserInformation();

                    EventBus.$emit('refreshNavigationBar');
                }
            }
        }
    }
</script>

<style>
    .gray-border {
        border: 0.5px solid #46464B
    }

    .logo {
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue